export const clearCache = async (sId = null, navigate = null) => {
  try {
    const cache = await caches.open('session-cache');
    const response = await cache.match('api_flag');
    if (response) {
      await cache.delete('api_flag');   
    } else {
      console.log('api_called_flag not found in cache.');
    }
  } catch (err) {
    console.error('Error handling cache:', err);
  }
  if (sId) {
    navigate(`/2fa/${sId}`);
  }
  return true;
};


export const triggerLogOut = async (bool = false) => {
  try {
    if(bool){
      localStorage.removeItem("user");
      localStorage.removeItem('secureID');
      localStorage.clear();  
      caches.open('timer-cache').then((cache) => {
        cache.delete('timerState');
      });
      return true;  
    }
    localStorage.removeItem("user");
    localStorage.removeItem('secureID');
    localStorage.clear();

    caches.open('timer-cache').then((cache) => {
      cache.delete('timerState');
    });
   
  } catch (error) {
    // Catch network errors or any unexpected issues
    console.info('An error occurred while logging out:', error);
    // Optionally, show a user-friendly message or alert
  }
};

export const getAuthInfo = () =>{
  var userDetails = localStorage.getItem('user') !== null ? localStorage.getItem('user') : null;
  const accessKey = localStorage.getItem('accessKey') ? localStorage.getItem('accessKey') : null;  
  var isAuthenticated = userDetails !== null && accessKey !== null ? true : false;
  const isAdmin = isAuthenticated && JSON.parse(userDetails)?.usertype === "Administrator" ? true :false;
  return { isAuthenticated , isAdmin };
}